import { put, takeLatest } from 'redux-saga/effects';
import {
  generatePhoneVerificationCodeFail,
  generatePhoneVerificationCodeRequest,
  generatePhoneVerificationCodeSuccess, verifyPhoneFail, verifyPhoneRequest, verifyPhoneSuccess,
} from './actions';
import { apiCall } from '../../effects';
import { notify } from '../notifications/actions';
import { getErrorNotification } from '../../util';
import VerificationCodeService from '../../../services/VerificationCodeService';

function* generatePhoneVerificationCode({
  payload,
}:ReturnType<typeof generatePhoneVerificationCodeRequest>) {
  try {
    const response = yield apiCall(VerificationCodeService.generateCode, payload);
    yield put(generatePhoneVerificationCodeSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(generatePhoneVerificationCodeFail());
  }
}

function* verifyPhoneCode({
  payload,
}:ReturnType<typeof verifyPhoneRequest>) {
  try {
    const response = yield apiCall(VerificationCodeService.verifyCode, payload);
    yield put(verifyPhoneSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(verifyPhoneFail());
  }
}

export default [
  takeLatest(generatePhoneVerificationCodeRequest.type, generatePhoneVerificationCode),
  takeLatest(verifyPhoneRequest.type, verifyPhoneCode),
];
